/**
 * 通用api，包含，登录，激活，注册等。
 */

import request from '@/config/axios';

/*----登录start----*/

/**
 * CommonGetCaptcha
 * 获取登录图片验证码
 * @return Object{img: base64code}
 */
export function CommonGetCaptcha(data) {
  return request({
    url: '/captcha',
    method: 'GET',
    params: data
  });
}

/**
 * CommonPostCompanyLogin
 * 请求登录
 * @param Object{} captchaCode, loginName, loginPwd, uuid
 * @return
 */
export function CommonPostCompanyLogin(data) {
  return request({
    url: '/company/login',
    method: 'POST',
    data
  });
}

/**
 * CommonPostCompanyLogout
 * 登出
 * @param
 * @return
 */
export function CommonPostCompanyLogout(data) {
  return request({
    url: '/company/logout',
    method: 'POST',
    data
  });
}
/*----登录end----*/

/*----账号激活start----*/
/**
 * CommonPostCompanySendEmailCode
 * 发送邮箱验证码
 * @param Object{} companyId, companyEmail, type, activationCode
 * @return
 */
export function CommonPostCompanySendEmailCode(data) {
  return request({
    url: '/company/sendVerificationCodeByEmail',
    method: 'POST',
    data
  });
}

/**
 * CommonPostCompanySendMessageCode
 * 发送短信验证码
 * @param Object{} companyId, companyContactsPhone, type
 * @return
 */
export function CommonPostCompanySendMessageCode(data) {
  return request({
    url: '/company/sendVerificationCodeByPhone',
    method: 'POST',
    data
  });
}

/**
 * CommonGetCompanyActivateCode
 * 验证激活码
 * @param Object{} activationCode
 * @return
 */
export function CommonGetCompanyActivateCode(data) {
  return request({
    url: '/company/activateActivationCode',
    method: 'GET',
    params: data
  });
}

/**
 * CommonPostCompanyActivateEmail
 * 验证邮箱code
 * @param Object{} companyId，companyEmail，verificationCode，loginPwd，type
 * @return
 */
export function CommonPostCompanyActivateEmail(data) {
  return request({
    url: '/company/activateVerificationCodeByEmail',
    method: 'POST',
    data
  });
}

/**
 * CommonPostCompanyActivateMessage
 * 验证短信code
 * @param Object{} companyId，companyContacts，companyContactsIdCode，verificationCode，companyContactsPhone，type
 * @return
 */
export function CommonPostCompanyActivateMessage(data) {
  return request({
    url: '/company/activateVerificationCodeByPhone',
    method: 'POST',
    data
  });
}
/*----账号激活end----*/

/*----忘记密码start----*/
/*--忘记密码里面验证接口共用账号激活里面的接口--*/
/**
 * CommonPostCompanyForgetPwd
 * 忘记密码
 * @param
 * @return
 */
export function CommonPostCompanyForgetPwd(data) {
  return request({
    url: '/company/forgetPassWord',
    method: 'POST',
    data
  });
}

/*----忘记密码end----*/

// 获取不同文档的ID
export function CommonGetIndexDocInfo(data) {
  return request({
    url: '/opendoc/preview/getIndexDocInfo',
    method: 'GET',
    params: data
  });
}